import { render, staticRenderFns } from "./ProductContentForum.vue?vue&type=template&id=ced26140&scoped=true&"
import script from "./ProductContentForum.vue?vue&type=script&lang=js&"
export * from "./ProductContentForum.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentForum.vue?vue&type=style&index=0&id=ced26140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced26140",
  null
  
)

export default component.exports